/* eslint-disable no-restricted-globals */
/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from 'react';
import ToolButton from 'components/atoms/tool_button';
import { useReactToPrint } from 'react-to-print';
import LineGraphic from 'components/atoms/line_graphic';
import BarChartGraphic from 'components/atoms/bar_chart_graphic';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'components/atoms/loader';
import { getClientFilters, searchFilters } from 'store/modules/market_store/actions';
import IconGraphic from 'assets/images/icon_graphic.svg';
import IconGraphicLine from 'assets/images/line_graphic.svg';
import { ApplicationState } from 'store';
import { MarketState } from 'store/modules/market_store/types';
import Buyers from 'components/molecules/buyers';
import Providers from 'components/molecules/providers';
import ResultsMarket from 'components/molecules/results_market';
import ProductsServices from 'components/molecules/products_services';
import { ProfileState } from 'store/modules/profile_store/types';
import companyId from 'services/company_id';
import OpenTutorial from 'components/atoms/open_tutorial';
import { Container } from './styles';
import FollowupsMarket from '../followups_market';

interface DashboardMarketProps {
  searchBarOpened: boolean;
  selectedPeriod: Array<object> | number;
  selectedFilter: number;
  exactSearch: boolean;
  params: any;
}

const DashboardMarket = (props: DashboardMarketProps) => {
  const dispatch = useDispatch();

  const { searchBarOpened, selectedPeriod, selectedFilter, exactSearch, params } = props;
  const [graphicShow, setGraphicShow] = useState<string>('chart_bar');
  const componentRef = useRef() as React.MutableRefObject<HTMLInputElement>;

  const { market, request } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const handleprint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'print_analise_mercado',
  });

  useEffect(() => {
    dispatch(getClientFilters(companyId(profile)));
    const params = {
      filter_id: selectedFilter,
      interval: selectedPeriod,
      exact_search: exactSearch,
    };
    selectedFilter > 0 && dispatch(searchFilters(params));
  }, [selectedFilter]);

  const renderRegionRows = (region: any, regionName: string) => (
    <div key={regionName}>
      <div className="row mb-2">
        <div className="col-6">{`${regionName}: `}</div>
        <div className="col-6 text-right">
          {`${Math.round(
            (Number(region?.licitacao) * 100) / Number(market?.total_entries),
          )}% (${region?.licitacao.toLocaleString('pt-br', {
            style: 'decimal',
            currency: 'BRL',
          })})`}
        </div>
      </div>
      <hr />
    </div>
  );

  return (
    <Container>
      <div
        className={`col-12 py-4 ${
          searchBarOpened ? 'col-lg-9 offset-lg-3 pl-md-5 pl-3' : 'col-lg-12 px-5'
        }`}
        ref={componentRef}
      >
        <div className="row">
          <div className="col-md-6 d-md-flex d-block">
            <h4 className="mb-1 mx-md-3">Análise de Mercado</h4>
            <OpenTutorial type="modal" source="market" />
          </div>
          <div className="col-md-6 d-flex justify-content-md-end">
            <ToolButton
              buttonClass="btn btn-primary btn-sm mr-1 mb-md-0 mb-1"
              buttonName="Imprimir"
              disabledPopoverText="Imprimir"
              disabledButton
              onButtonClick={() => handleprint()}
            />
          </div>
        </div>
        {request?.search?.loading ? (
          <Loader />
        ) : (
          <>
            <div className="row mb-3 mt-3">
              <div className="col-md-12">
                <div className="card shadow">
                  <div className="p-2 text-white" style={{ backgroundColor: '#956CCA' }}>
                    <div className="d-flex align-items-center">
                      <i className="material-icons mr-2">description</i>
                      <b>
                        <span className="ml-2 mt-3">
                          Total de Compras Públicas: {market?.total_entries.toLocaleString('pt-BR')}
                        </span>
                      </b>
                    </div>
                  </div>
                  <div className="p-3">
                    <div className="mb-3 d-print-none" role="group">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm mr-2"
                        onClick={() => setGraphicShow('chart_bar')}
                        style={{ zIndex: 'unset' }}
                      >
                        <img
                          className="card-img-top"
                          src={IconGraphic}
                          alt="recursos"
                          style={{ width: '20px' }}
                        />
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => setGraphicShow('chart_accumulated')}
                        style={{ zIndex: 'unset' }}
                      >
                        <img
                          className="card-img-top"
                          src={IconGraphicLine}
                          alt="recursos"
                          style={{ width: '20px' }}
                        />
                      </button>
                    </div>
                    {graphicShow === 'chart_bar' ? <BarChartGraphic /> : <LineGraphic />}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3 mb-md-0">
                <div className="card">
                  <div className="pl-2 my-2 d-flex align-items-center">
                    <i className="material-icons">place</i>
                    <b className="pl-1 mt-2">Licitações por região</b>
                  </div>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item" style={{ backgroundColor: '#EBECEF' }}>
                      <div className="row">
                        <div className="col-6">
                          <strong>Região</strong>
                        </div>
                        <div className="col-6 text-right">
                          <strong>Licitações</strong>
                        </div>
                      </div>
                    </li>
                    {market?.estados?.regions?.map((result: any) => (
                      <li key={result.id} className="list-group-item">
                        <h5>{result.regionName}</h5>
                        {renderRegionRows(result.sudeste, 'Sudeste')}
                        {renderRegionRows(result.norte, 'Norte')}
                        {renderRegionRows(result.sul, 'Sul')}
                        {renderRegionRows(result.nordeste, 'Nordeste')}
                        {renderRegionRows(result.centro_oeste, 'Centro-Oeste')}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card">
                  <div>
                    <div className="pl-2 my-2 d-flex align-items-center">
                      <i className="material-icons">business</i>
                      <b className="pl-1 mt-2">Licitações por modalidade</b>
                    </div>
                  </div>
                  <ul
                    className="list-group list-group-flush"
                    style={{ maxHeight: '330px', overflowY: 'auto' }}
                  >
                    <li className="list-group-item" style={{ backgroundColor: '#EBECEF' }}>
                      <div className="row">
                        <div className="col-6">
                          <strong>Modalidade</strong>
                        </div>
                        <div className="col-6 text-right">
                          <strong>Licitações</strong>
                        </div>
                      </div>
                    </li>
                    {market?.modalities?.map((mod: any) => (
                      <li key={mod.modalidade} className="list-group-item">
                        <div className="row">
                          <div className="col-6">{mod.modalidade}</div>
                          <div className="col-6 text-right">
                            {`${mod.total.toLocaleString('pt-br', {
                              style: 'decimal',
                              currency: 'BRL',
                            })} (${Math.round(
                              (mod.total * 100) / Number(market?.total_entries),
                            )}%)`}
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-6 mb-3 mb-md-0">
                <Buyers params={params} selectedFilter={selectedFilter} />
              </div>
              <div className="col-md-6">
                <Providers params={params} selectedFilter={selectedFilter} />
              </div>
            </div>
            <ResultsMarket params={params} />
            <ProductsServices params={params} />
            <FollowupsMarket params={params} />
          </>
        )}
      </div>
    </Container>
  );
};
export default DashboardMarket;
